"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionWidgetBase = void 0;
var React = require("react");
var journey_services_1 = require("@athena-portal/journey-services");
var ValidationResult_1 = require("../components/ValidationResult");
var Types_1 = require("../../Types");
var core_1 = require("@athena-portal/core");
var WidgetBase_1 = require("../WidgetBase");
var journey_model_1 = require("@athena-portal/journey-model");
var react_html_parser_1 = require("react-html-parser");
var QuestionWidgetBase = exports.QuestionWidgetBase = /** @class */ (function (_super) {
    __extends(QuestionWidgetBase, _super);
    function QuestionWidgetBase(props) {
        var _this = _super.call(this, props) || this;
        _this.bindFromField = _this.bindFromField.bind(_this);
        _this.bindToField = _this.bindToField.bind(_this);
        _this.handleOnBlurEvent = _this.handleOnBlurEvent.bind(_this);
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        return _this;
    }
    QuestionWidgetBase_1 = QuestionWidgetBase;
    QuestionWidgetBase.prototype.validateInternal = function (value) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.questionValidator.validate(value, {
                            journey: this.props.journey,
                            page: this.props.page,
                            question: this.props.question,
                            interaction: this.props.interaction,
                            engine: this.props.engine
                        })];
                    case 1:
                        result = _a.sent();
                        this.props.onValidate(this.props.question.name, result);
                        if (!this.isValid()) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.executeEvent("onValidateSuccess")];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.executeEvent("onValidateFail")];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    QuestionWidgetBase.prototype.render = function () {
        var htmlLabel = this.getSetting("htmlLabel", "");
        var htmlInfo = this.getSetting("htmlInfo", "");
        return (React.createElement("div", { className: "form-group ".concat(this.getSetting("cssClass", "")) },
            React.createElement("label", { htmlFor: this.props.question.name },
                htmlLabel ? this.renderHtml(htmlLabel) : this.props.question.label,
                this.isMandatory() &&
                    (this.props.journey && process.env.REACT_APP_MANDATORY_QUESTION_SUFFIX ? process.env.REACT_APP_MANDATORY_QUESTION_SUFFIX : " *")),
            htmlInfo && this.renderHtml(htmlInfo),
            React.createElement("div", { className: "input-group", role: this.getSetting("role", ""), "aria-label": this.getSetting("ariaLabel", "") },
                this.hasPlaceholder(QuestionWidgetBase_1.PREFIX_PLACEHOLDER) && (React.createElement("div", { className: "input-group-prepend" }, this.renderPlaceholder(QuestionWidgetBase_1.PREFIX_PLACEHOLDER))),
                this.renderInputField(),
                this.hasPlaceholder(QuestionWidgetBase_1.POSTFIX_PLACEHOLDER) && (React.createElement("div", { className: "input-group-append" }, this.renderPlaceholder(QuestionWidgetBase_1.POSTFIX_PLACEHOLDER)))),
            this.getSetting("helpText") && React.createElement("small", { id: this.props.question.name + "HelpBlock", className: "form-text text-muted" }, this.getSetting("helpText")),
            this.renderValidationResult(),
            this.getSetting("validFeedback") && this.isValid() && React.createElement("div", { className: "valid-feedback d-block" }, this.getSetting("validFeedback"))));
    };
    QuestionWidgetBase.prototype.getSetting = function (setting, defaultValue) {
        if (!this.props.question.settings || this.props.question.settings[setting] === undefined) {
            return defaultValue;
        }
        return this.props.question.settings[setting];
    };
    QuestionWidgetBase.prototype.bindFromField = function (field) {
        return journey_services_1.ObjectManipulator.fetchFieldValue(field, this.props.interaction);
    };
    QuestionWidgetBase.prototype.bindToField = function (event) {
        this.props.onStateChange(this.props.question.interactionField, event.target.value);
        var validationOnFieldChange = process.env.REACT_APP_VALIDATION_ON_FIELD_CHANGE ? process.env.REACT_APP_VALIDATION_ON_FIELD_CHANGE : "true";
        if (validationOnFieldChange === "true") {
            this.validateInternal(event.target.value);
        }
    };
    QuestionWidgetBase.prototype.handleOnBlurEvent = function (event) {
        this.validateInternal(event.target.value);
        this.executeNativeEvent(event);
    };
    QuestionWidgetBase.prototype.handleOnChangeEvent = function (event) {
        this.bindToField(event);
        this.executeNativeEvent(event);
    };
    QuestionWidgetBase.prototype.renderValidationResult = function () {
        return React.createElement(ValidationResult_1.ValidationResult, { result: this.props.validations[this.props.question.name] });
    };
    QuestionWidgetBase.prototype.isValid = function () {
        var result = this.props.validations[this.props.question.name];
        if (result && result.valid) {
            return true;
        }
        return false;
    };
    QuestionWidgetBase.prototype.getInputValidationClass = function () {
        var result = this.props.validations[this.props.question.name];
        if (!result) {
            return null;
        }
        if (result.valid) {
            if (this.getSetting("validFeedback")) {
                return "is-valid";
            }
        }
        else {
            return "is-invalid";
        }
        return null;
    };
    QuestionWidgetBase.prototype.isMandatory = function () {
        if (this.props.question.validations) {
            return this.props.question.validations.some(function (x) { return x.type === "mandatory"; });
        }
        return false;
    };
    QuestionWidgetBase.prototype.isReadOnly = function () {
        return this.getSetting("readOnlyExpression") && journey_services_1.ExpressionEvaluator.evaluateBoolean(this.getSetting("readOnlyExpression"), this.props.interaction);
    };
    QuestionWidgetBase.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            }
        });
    };
    QuestionWidgetBase.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    var QuestionWidgetBase_1;
    QuestionWidgetBase.PREFIX_PLACEHOLDER = "prefix";
    QuestionWidgetBase.POSTFIX_PLACEHOLDER = "postfix";
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.QuestionValidator),
        __metadata("design:type", Object)
    ], QuestionWidgetBase.prototype, "questionValidator", void 0);
    QuestionWidgetBase = QuestionWidgetBase_1 = __decorate([
        (0, journey_model_1.settings)([
            { name: "helpText", type: journey_model_1.TypeDescriptions.Html },
            { name: "validFeedback", type: journey_model_1.TypeDescriptions.String },
            { name: "readOnlyExpression", type: journey_model_1.TypeDescriptions.Expression },
            { name: "role", type: journey_model_1.TypeDescriptions.String },
            { name: "ariaLabel", type: journey_model_1.TypeDescriptions.String },
            { name: "htmlLabel", type: journey_model_1.TypeDescriptions.Html },
            { name: "htmlInfo", type: journey_model_1.TypeDescriptions.Html },
            { name: "cssClass", type: journey_model_1.TypeDescriptions.CssClass },
        ]),
        (0, journey_model_1.events)([
            journey_model_1.Event.onValidateFail,
            journey_model_1.Event.onValidateSuccess
        ]),
        (0, journey_model_1.questionConfiguration)({
            noChildren: true
        }),
        __metadata("design:paramtypes", [Object])
    ], QuestionWidgetBase);
    return QuestionWidgetBase;
}(WidgetBase_1.WidgetBase));
//# sourceMappingURL=QuestionWidgetBase.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/plugin-journey/dist/widgets/input/QuestionWidgetBase.js
// module id = 182
// module chunks = 0